import {type ComponentProps} from 'react';

import GooglePlayIcon from '@/assets/icons/google-play-icon.svg?react';
import {GOOGLE_STORE_LINK} from '@/shared/consts/socialLinks';

export type GooglePlayLinkIconProps = Omit<
  ComponentProps<'a'>,
  'href' | 'children' | 'aria-label'
> & {
  iconProps?: ComponentProps<'svg'>;
};

function GooglePlayLinkIcon({
  className,
  iconProps,
  ...rest
}: GooglePlayLinkIconProps) {
  return (
    <a
      {...rest}
      className={className}
      href={GOOGLE_STORE_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="GooglePlay"
    >
      <GooglePlayIcon {...iconProps} />
    </a>
  );
}

export default GooglePlayLinkIcon;
